import options from './content-header.component';

export default {
    selector: 'dtContentHeader',
    options
};
